import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import {
  getAll,
  deleteContrat,
  updateContract,
} from "../../../../services/RHService/ContratDePartegeService";
import moment from "moment";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../../../components/layouts/WithLoader";

const InternMissionlist = ({ startLoading, stopLoading }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const { ExportCSVButton } = CSVExport;
  const [contract, setContract] = useState({});
  const [selectedContract, setSelectedContract] = useState([]);

  const [inputList, setInputList] = useState([]);
  //afficher les information par defaut dans le Model
  const handleShow = (contrat) => {
    setSelectedContract(contrat);
    setInputList(contrat.charges);

    setShow(true);
  };
  const fetchData = async () => {
    startLoading();
    getAll(getCurrentUserId()).then((response) => {
      setContract(response.data.success);
    }).finally(() => {
      stopLoading();
    });
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    console.log(e.target);
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };
  const handleAddClick = () => {
    setInputList([
      ...inputList,
      { nomCharge: "", frais: "", isDeleted: false },
    ]);
  };
  useEffect(() => {
    setSelectedContract((prevState) => ({
      ...prevState,
      charges: inputList,
    }));
  }, [inputList]);

  const options = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };
  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    { dataField: "intitule", text: "Intitulé" },
    { dataField: "nomBenif", text: "Par " },
    { dataField: "dateDeb", text: "Date Début" },
    { dataField: "dateFin", text: "Date fin" },
    {
      dataField: "dd",
      text: "Tot.Charge",
      formatter: (cell, row) => `${row.totCharge} Dt`,
    },
    {
      dataField: "actions",
      text: "Actions",
      csvExport: false,
      formatter: (cell, row) => {
        return (
          <div class="center" style={{ display: "flex" }}>
            <Button
              style={{
                "background-color": "#000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleShow(row);
              }}
            >
              <i class="fa-solid fa-pencil"></i>
            </Button>
            <Button
              className="mx-1"
              style={{
                "background-color": "#696969",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
            >
              <Link
                to={`/detailDeContratDePartage?idContratP=${row.idContratP}`}
              >
                <i
                  className="fa-solid fa-eye eye-icon"
                  style={{ color: "white" }}
                ></i>
              </Link>
            </Button>
            <Button
              style={{
                "background-color": "#cc0000",
                color: "white",
                "border-color": "transparent",
                "border-radius": "0px",
              }}
              onClick={() => {
                handleDelete(row.idContratP);
              }}
            >
              <i class="fa-solid fa-trash-can"></i>
            </Button>
          </div>
        );
      },
    },
  ];
  const handleDelete = async (employeeID) => {
    await deleteContrat(employeeID, setContract);
  };
  const handleUpdate = async (event) => {
    event.preventDefault();
    // Convert date format to "dd/MM/yyyy"
    const { dateDeb, dateFin, ...otherFormData } = selectedContract;
    const formattedFormData = {
      ...otherFormData,
      dateDeb: moment(selectedContract.dateDeb).format("YYYY-MM-DD"),
      dateFin: moment(selectedContract.dateFin).format("YYYY-MM-DD"),
    };

    console.log(formattedFormData.charges);
    try {
      await updateContract(formattedFormData.idContratP, formattedFormData);
      fetchData();
      handleClose();
    } catch (error) {
      alert(error.message);
    }
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <ToolkitProvider
        keyField="id"
        data={contract}
        columns={columns}
        exportCSV={{
          fileName: "missions interne.csv",
          onlyExportFiltered: true,
          exportAll: true,
        }}
      >
        {(props) => (
          <div>
            <Modal show={show} onHide={handleClose} size="xl">
              <Modal.Header closeButton>
                <Modal.Title>Modifier les informations</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form onSubmit={handleUpdate}>
                  <Container>
                    <Row>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label for="exampleInputPassword1">
                            Intitulé de Contrat
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-border"
                            name="intitule"
                            value={
                              selectedContract ? selectedContract.intitule : ""
                            }
                            onChange={(e) =>
                              setSelectedContract({
                                ...selectedContract,
                                intitule: e.target.value,
                              })
                            }
                            placeholder="Intitulé de mission "
                          />{" "}
                        </div>

                        <div className="form-group">
                          <label for="exampleInputPassword1">
                            Nom de bénificitaire
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-border"
                            name="nomBenif"
                            value={
                              selectedContract ? selectedContract.nomBenif : ""
                            }
                            onChange={(e) =>
                              setSelectedContract({
                                ...selectedContract,
                                nomBenif: e.target.value,
                              })
                            }
                            placeholder="Nom de bénificitaire"
                          />{" "}
                        </div>
                        <div className="form-group">
                          <label for="exampleInputPassword1">Contact</label>
                          <input
                            type="text"
                            className="form-control form-control-border"
                            name="contact"
                            value={
                              selectedContract ? selectedContract.contact : ""
                            }
                            onChange={(e) =>
                              setSelectedContract({
                                ...selectedContract,
                                contact: e.target.value,
                              })
                            }
                            placeholder="Contact"
                          />{" "}
                        </div>
                        <div className="form-group">
                          <label>Date de début</label>
                          <div
                            className="input-group date"
                            id="reservationdate"
                            data-target-input="nearest"
                          >
                            <input
                              type="date"
                              id="start"
                              name="dateDeb"
                              value={
                                selectedContract ? selectedContract.dateDeb : ""
                              }
                              onChange={(e) =>
                                setSelectedContract({
                                  ...selectedContract,
                                  dateDeb: e.target.value,
                                })
                              }
                              min="1900-01-01"
                              className="form-control form-control-border"
                            />{" "}
                          </div>
                        </div>
                        <div className="form-group">
                          <label for="exampleSelectBorder">
                            Mode de paiment{" "}
                          </label>

                          <select
                            className="custom-select form-control-border"
                            name="modePaiment"
                            value={
                              selectedContract
                                ? selectedContract.modePaiment
                                : ""
                            }
                            onChange={(e) =>
                              setSelectedContract({
                                ...selectedContract,
                                modePaiment: e.target.value,
                              })
                            }
                          >
                            <option value="espéce">Espéce</option>
                            <option value="chéque">Chéque</option>
                            <option value="virementBoncaire">
                              Virement boncaire
                            </option>
                          </select>
                        </div>
                        {selectedContract &&
                          ((selectedContract.modePaiment === "chéque" && (
                            <div className="form-group">
                              <label>RIB</label>
                              <input
                                type="text"
                                name="rib"
                                value={selectedContract.rib}
                                onChange={(e) =>
                                  setSelectedContract({
                                    ...selectedContract,
                                    rib: e.target.value,
                                  })
                                }
                                className="form-control form-control-border"
                                placeholder="RIB"
                              />
                            </div>
                          )) ||
                            (selectedContract.modePaiment ===
                              "virementBoncaire" && (
                                <div>
                                  <label className="form-group">
                                    <label>RIB </label>
                                    <input
                                      type="text"
                                      name="rib"
                                      value={selectedContract.rib}
                                      onChange={(e) =>
                                        setSelectedContract({
                                          ...selectedContract,
                                          rib: e.target.value,
                                        })
                                      }
                                      className="form-control form-control-border"
                                      placeholder="RIB"
                                    />
                                  </label>
                                </div>
                              )))}
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="form-group">
                          <label>Date de fin</label>
                          <div
                            className="input-group date"
                            id="reservationdate"
                            data-target-input="nearest"
                          >
                            <input
                              type="date"
                              id="start"
                              name="dateFin"
                              value={
                                selectedContract ? selectedContract.dateFin : ""
                              }
                              onChange={(e) =>
                                setSelectedContract({
                                  ...selectedContract,
                                  dateFin: e.target.value,
                                })
                              }
                              min="1900-01-01"
                              className="form-control form-control-border"
                            />{" "}
                          </div>
                        </div>

                        <div className="form-group">
                          <label for="exampleInputPassword1">Description</label>
                          <textarea
                            type="Textarea"
                            rows="2"
                            cols="33"
                            name="desc"
                            value={
                              selectedContract ? selectedContract.desc : ""
                            }
                            onChange={(e) =>
                              setSelectedContract({
                                ...selectedContract,
                                desc: e.target.value,
                              })
                            }
                            className="form-control form-control-border"
                            placeholder="Description"
                          ></textarea>
                        </div>
                        <label for="exampleInputPassword1">Charges :</label>
                        {selectedContract && selectedContract.charges ? (
                          selectedContract.charges.map((charge, index) => (
                            <div className="col-md-3" key={index}>
                              <div className="box">
                                <input
                                  name="nomCharge"
                                  className="form-control form-control-border"
                                  placeholder="Nom de charge"
                                  value={charge.nomCharge}
                                  onChange={(e) => handleInputChange(e, index)}
                                />
                                <input
                                  name="frais"
                                  className="form-control form-control-border ml10"
                                  placeholder="Charge"
                                  value={charge.frais}
                                  onChange={(e) => handleInputChange(e, index)}
                                />
                                <input
                                  name="isDeleted"
                                  hidden
                                  value={charge.isDeleted}
                                  onChange={(e) => handleInputChange(e, index)}
                                />
                                <div className="btn-box">
                                  {selectedContract.charges.length > 1 && (
                                    <button
                                      className="mr10 mx-1 m-1"
                                      type="button"
                                      style={{
                                        backgroundColor: "black",
                                        color: "white",
                                        borderRadius: "50%",
                                        borderColor: "black",
                                      }}
                                      onClick={() => handleRemoveClick(index)}
                                    >
                                      <i className="fa-solid fa-minus"></i>
                                    </button>
                                  )}
                                  {selectedContract.charges.length - 1 ===
                                    index && (
                                      <button
                                        onClick={handleAddClick}
                                        type="button"
                                        style={{
                                          backgroundColor: "black",
                                          color: "white",
                                          borderRadius: "50%",
                                          borderColor: "black",
                                        }}
                                      >
                                        <i className="fa-solid fa-plus"></i>
                                      </button>
                                    )}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p>Loading charges...</p>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Fermer
                </Button>
                <Button variant="dark" onClick={handleUpdate}>
                  Modifier
                </Button>
              </Modal.Footer>
            </Modal>

            <br />
            <section className="content ">
              <div class="container-fluid">
                <div class="card card-dark">
                  <div class="card-body">
                    <h5 class="card-title">Ajouter un Contrat de partage</h5>

                    <Link to="/add_intern_mission">
                      <button class="btn btn-dark  float-right">
                        <i class="fas fa-plus"></i>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </section>
            <section className="content ">
              <div class="container-fluid">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title">Liste des Contrats de partage</h3>
                    <ExportCSVButton
                      {...props.csvProps}
                      className="btn1 float-right "
                    >
                      Export CSV
                    </ExportCSVButton>
                  </div>
                  <BootstrapTable
                    {...props.baseProps}
                    data={contract}
                    columns={columns}
                    bordered={false}
                    pagination={paginationFactory(options)}
                  />
                </div>
              </div>
            </section>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};
export default withLoader(InternMissionlist);
